module.exports = __webpack_public_path__ + "static/media/icon_181.11583c1f.svg";